module.exports = __webpack_public_path__ + "img/paytm.c6ed1599.svg";